import React from 'react'
import { useState, useRef } from 'react';
import axios from 'axios';

const CarrerComponent = () => {
	const[name, setName] = useState('');
	const[email, setEmail] = useState('');
	const[tel, setTel] = useState('');
	const[subject, setSubJect] = useState('');
	const[message, setMessage] = useState('');
	
	
	const nameRef = useRef();
	const emailRef = useRef();
	const telRef = useRef();
	const subjectRef = useRef();
	const messageRef = useRef();


	const sendData = (e) =>{
		
		e.preventDefault();
		var reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
		if(name === ''){
			alert("You didn't enter Full Name.")
			nameRef.current.focus();
			return false;
		}
		else if (email === ''){
			alert("You didn't enter a Email");
			emailRef.current.focus();
			return false;
		}
		else if(!reg.test(email)){
			alert("Invalid Email ID");
			emailRef.current.select();
			return false;
		}
		else if (tel === "") {
			alert("You didn't enter a phone number.");
			telRef.current.focus();
			return false;
		}
		else if (isNaN(tel)) {
			alert("The phone number contains illegal characters.");
			telRef.current.select();
			return false;
		}
		else if ((tel.length > 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if ((tel.length < 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if (subject === "") {
			alert("You didn't enter your subject.");
			subjectRef.current.focus();
			return false;
		}
		else if (message === "") {
			alert("Please berief your self");
			messageRef.current.focus();
			return false;
		}
		else{
			axios.post('url',{
				firstName: name,
				phoneNo: tel,
				email: email,
				message: message,
				Subject: subject,
			},
			{
				headers : {"Content-Type": "application/json"}
				
			}).then((response)=>{
				console.log(response)
			}).then((error)=>{
				console.log(error)
			})
		}
	}
  return (
    <>
		<section id="c-heroAboutUs" className="c-sectionHero">
			<div className="container  pb-0">
				<div className="row">
					<div className="col-md-8 col-sm-12 c-heroContentCol">
						<div className="c-heroContent">
							<h5 className="c-heading46Bold">Build Your Career with Finayo</h5>
							<p className="c-para22Regular">When you work here, you’re connected to a global community working together to solve the most critical technology challenges.</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section id="c-sectionLenderUnlock" className="c-sectionWrapper pt-30 pb-40">
			<div className="container">
				<div className="c-sectionHeader mb-20">
					<h5 className="c-openingBold">Our Current Openings</h5>
				</div>
				<div className="row c-lenderUnlockBoxes">
					<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
						<div className="opening_box">
							<div className="c-lubPercent">Java Developer </div>
							<div className="c-lubInfo">5-8 Year Experience</div>
							<p>Location : Delhi</p>
							<a href="#" className="appy_btn">Apply Now</a>
						</div>
					</div>
					<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
						<div className="opening_box">
							<div className="c-lubPercent">Java Developer </div>
							<div className="c-lubInfo">5-8 Year Experience</div>
							<p>Location : Delhi</p>
							<a href="#" className="appy_btn">Apply Now</a>
						</div>
					</div>
					<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
						<div className="opening_box">
							<div className="c-lubPercent">Lead Java Developer </div>
							<div className="c-lubInfo">5-8 Year Experience</div>
							<p>Location : Delhi</p>
							<a href="#" className="appy_btn">Apply Now</a>
						</div>
					</div>
				</div>			
			</div>
		</section>
		<section className="ble_sectoion why-choose-us-sec pb-100 mt-10">
			<div className="auto-container">
				<div className="sec-title light mb-20">
					<h2>Job Application Process</h2>
				</div>	
				<div className="carer_main">
					<div className="row">
						<div className="col-lg-3 col-md-6 m-b-30">
							<img src="./images/team/1-icon-arrow.svg" />
							<h5>Online Apply</h5>
							<span className="text">If you want to be part of our growing team, upload your resume and send your application.</span>
						</div>
						<div className="col-lg-3 col-md-6 m-b-30">
							<img src="./images/team/3-icon-arrow.svg" />
							<h5>Online assessments</h5>
							<span className="text">Take the test and wait patiently for the evaluation process might take a day or two.</span>
						</div>
						<div className="col-lg-3 col-md-6 m-b-30">
							<img src="./images/team/4-icon-arrow.svg" />
							<h5>Assessment center / interview</h5>
							<span className="text">Once selected, you will be called for a face-to-face interview round.</span>
						</div>				
						<div className="col-lg-3 col-md-6 m-b-30">
							<img src="./images/team/5-icon-arrow.svg" />
							<h5>Decision / Offer</h5>
							<span className="text">Once selected, we will share the offer letter with you.</span>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12 col-md-12 m-b-30 text-center main-contact-area">
							<div className="sec-title light mb-20 pt-50">
								<h2>Apply For Job</h2>
							</div> 
						</div> 
					</div>
				</div>
			</div>
		</section>
		<section>
			<div className="care_main_form">
				<div>
					<div className="row">
						<div className="col-lg-12 col-md-6 m-b-30 main-contact-area contact-form">		 
							<div className="iner_from">
								<form>
									<div className="row">
										<div className="col-lg-6 col-sm-6">
											<div className="form-group has-error">
												<label>Full Name</label>
												<input type="text" name="name" id="name" className="form-control" 
												required="" data-error="Please enter your name" placeholder="Name" 
												onChange={(e)=>{setName(e.target.value)}} />
											</div>
										</div>
										<div className="col-lg-6 col-sm-6">
											<div className="form-group">
												<label>Phone Number</label>
												<input type="text" name="phone" id="phone" 
												required="" data-error="Please enter your number" className="form-control"
												placeholder="Your Phone" 
												onChange={(e)=>{setTel(e.target.value)}} />
											</div>
										</div>
										<div className="col-lg-6 col-sm-6">
											<div className="form-group">
												<label>Email Address</label>
												<input type="email"
												 name="email" id="email"
												 className="form-control" 
												 required="" 
												 data-error="Please enter your email" 
												 placeholder="Email Address" 
												 onChange={(e)=>{setEmail(e.target.value)}} />
											</div>
										</div>		
										<div className="col-lg-6 col-sm-6">
											<div className="form-group">
												<label>Apply for</label>
												<input type="text" name="subject" 
												id="subject" className="form-control" 
												required="" data-error="Please enter your subject" placeholder="Subject" 
												onChange={(e)=>{setSubJect(e.target.value)}} />
											</div>
										</div>	
										<div className="col-12">
											<div className="form-group">
												<label>Why you want to join Finayo</label>
												<textarea name="message" className="form-control" 
												id="message" cols="20" rows="3" 
												required="" data-error="Write your message" placeholder="Message"
												onChange={(e)=>{setMessage(e.target.value)}}
												></textarea>
											</div>
										</div>	
									   <div className="col-lg-12 col-sm-12">
											<div className="form-group">
												<input type="file"  id="upload" hidden/>
												<label htmlFor="upload" className="upoad_btn w-100 pl-3">Choose file</label>
											</div>
										</div>										
										<div className="col-lg-12 col-md-12">
											<button type="submit" className="default-btn2 disabled" style={{pointerEvents: "all", cursor: "pointer"}} onClick={sendData} >
												<span>Submit</span>
											</button>
											<div id="msgSubmit" className="h3 text-center hidden"></div>
											<div className="clearfix"></div>
										</div>
									</div>
								</form> 
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</>

  )
}

export default CarrerComponent